<script setup lang="ts">
import { ref, computed, inject, Ref } from 'vue';
import Button from 'primevue/button';
import Fluid from 'primevue/fluid';
import InputNumber from 'primevue/inputnumber';
import MultiSelect from 'primevue/multiselect';

const dialogRef = inject('dialogRef') as Ref;
const roomData = dialogRef?.value?.data?.roomData;
const isTourModal = dialogRef?.value?.data?.isTourModal;
const onApply = dialogRef?.value?.options?.emits?.onApply;

const handleHotelRoomCate = () => {
  return isTourModal
    ? []
    : roomData.map((room: any, index: number) => {
        return index;
      });
};

const optionMarginData = ref({
  adultMargin: 0,
  childMargin: 0,
  hotelRoomCate: handleHotelRoomCate()
});

const hotelRoomCateList = computed(() =>
  roomData.map((room, index) => {
    return {
      value: index,
      label: room.room
    };
  })
);

const onClickApply = () => {
  onApply(optionMarginData.value);
  dialogRef?.value.close();
};

const allowApply = computed(() => !!optionMarginData.value.hotelRoomCate.length);
</script>
<template>
  <div>
    <div>
      <span>{{ $t('worksheet.adjust_margin_subtitle') }}</span>
    </div>
    <Fluid class="mt-3">
      <div class="flex align-content-start gap-6">
        <div class="field flex-1">
          <label for="adultMargin">{{ $t('worksheet.adult_margin') }}</label>
          <InputNumber id="adultMargin" inputId="adultMargin" v-model="optionMarginData.adultMargin" :minFractionDigits="2" :maxFractionDigits="2" />
        </div>
        <div class="field flex-1">
          <label for="childMargin">{{ $t('worksheet.child_margin') }}</label>
          <InputNumber id="childMargin" inputId="childMargin" v-model="optionMarginData.childMargin" :minFractionDigits="2" :maxFractionDigits="2" />
        </div>
      </div>
    </Fluid>
    <div class="field" v-if="!isTourModal">
      <label for="hotelRoomCate">{{ `${$t('worksheet.adjust_margin_apply')} ${$t('worksheet.adjust_margin_to')}` }}</label>
      <div>
        <MultiSelect inputId="hotelRoomCate" display="chip" v-model="optionMarginData.hotelRoomCate" :options="hotelRoomCateList" optionLabel="label" optionValue="value" class="w-full">
          <template #option="slotProps">
            <p>
              {{ slotProps.option.label }}
            </p>
          </template>
        </MultiSelect>
      </div>
    </div>
    <p class="mt-3">{{ $t('worksheet.adjust_margin_note') }}</p>
    <div v-if="allowApply || isTourModal" class="w-full flex justify-content-center button-wrapper">
      <Button data-testid="adjust_margin_apply" @click="onClickApply()">{{ $t('worksheet.adjust_margin_apply') }}</Button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.min-w-10rem {
  min-width: 10rem;
}

.width-30 {
  width: 30%;
}

.width-15 {
  width: 15%;
}

.width-80 {
  width: 80%;
}

.classes-available-header,
.fares-available-header {
  color: $col-white;
  padding: 0.8rem 1.2rem;
  font-weight: 700;
}

.classes-available-detail {
  border: $border-greybd;
}

.outbound-detail {
  border-bottom: $border-greybd;
  .title {
    border-right: $border-greybd;
    min-width: 6rem;
  }
}

.return-detail {
  border-top: $border-greybd;

  .title {
    border-right: $border-greybd;
    min-width: 8rem;
  }
}

.box-bodder {
  border: $border-greybd;
  padding: 8px;
  text-align: center;
}

.classes-available-header {
  background-color: $col-primary;
}
</style>
